import React from 'react';
import { Tag, Icon, Tooltip } from '@dexma/ui-components';
import { StyledTableCell } from 'adapter/in/common/components/widgets/Table/style';
/* eslint-disable react/jsx-props-no-spreading */
type TableCellProps = {
    children?: JSX.Element;
    align: string | null;
    backgroundColor: string | null;
    tooltip: string | null;
    xs?: number | null;
    sm?: number | null;
    md?: number | null;
    lg?: number | null;
    xsOffset?: number | null;
    smOffset?: number | null;
    mdOffset?: number | null;
    lgOffset?: number | null;
};

const getFlexAlignment = (align: string | null) => {
    switch (align) {
        case 'left':
        case 'start':
            return 'flex-start';
        case 'right':
        case 'end':
            return 'flex-end';
        default:
            return 'center';
    }
};

export const TableCell = (props: TableCellProps) => {
    const { children, tooltip, ...rest } = props;

    const flexAlign = getFlexAlignment(props.align);

    return (
        <StyledTableCell {...rest} flexAlign={flexAlign}>
            {tooltip !== undefined ? (
                <Tooltip title={props.tooltip}>
                    <>{props.children}</>
                </Tooltip>
            ) : (
                <>{children}</>
            )}
        </StyledTableCell>
    );
};
type TagCellProps = {
    tagValue: string | null;
    tagBackground: string;
    tagIcon: string | null;
    tagType: string | null;
} & TableCellProps;
export const TagCellComponent = (props: TagCellProps) => {
    const { tagBackground, tagValue, tagIcon, tagType, ...rest } = props;
    return (
        <TableCell {...rest}>
            <Tag color={tagBackground} variant={tagType || undefined} icon={tagIcon}>
                {tagValue}
            </Tag>
        </TableCell>
    );
};

type RegularCellProps = {
    value: string | null;
    fontColor: string | null;
    fontWeight: number | null;
} & TableCellProps;

export const RegularCellComponent = (props: RegularCellProps) => {
    const { value, ...rest } = props;
    return (
        <TableCell {...rest}>
            <>{value}</>
        </TableCell>
    );
};

type IconCellProps = {
    value: string | null;
    iconColor?: string;
} & TableCellProps;

export const IconCellComponent = (props: IconCellProps) => {
    const { value, iconColor, ...rest } = props;

    return (
        <TableCell {...rest}>
            <>
                <Icon name={value} color={iconColor} />
            </>
        </TableCell>
    );
};
